import { render, staticRenderFns } from "./DialogHeadCount.vue?vue&type=template&id=876f927a&scoped=true&"
import script from "./DialogHeadCount.vue?vue&type=script&lang=js&"
export * from "./DialogHeadCount.vue?vue&type=script&lang=js&"
import style0 from "./DialogHeadCount.vue?vue&type=style&index=0&id=876f927a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876f927a",
  null
  
)

export default component.exports